module.exports = __webpack_public_path__ + "img/weixin-ryxy.4168e739.png";